import { render, staticRenderFns } from "./OptionSetLinkedToProductsModal.vue?vue&type=template&id=9f50d634&scoped=true"
import script from "./OptionSetLinkedToProductsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./OptionSetLinkedToProductsModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./OptionSetLinkedToProductsModal.vue?vue&type=style&index=0&id=9f50d634&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f50d634",
  null
  
)

export default component.exports